<div class="tab-content">
  <!-- Custom tooltip that follows mouse -->
  <div
    *ngIf="tooltipVisible"
    class="custom-contextual-tooltip"
    [style.left.px]="tooltipX"
    [style.top.px]="tooltipY"
    role="tooltip">
    {{ tooltipText }}
  </div>
  <div class="container-fluid px-0">
    <!-- Row 1 -->
    <div class="row forecast-row kt-margin-b-25">
      <div class="col-md-8 forecast-col">
        <div class="chart-card">
          <div class="chart-header">
            <h3>Projected Consumption (lbs)</h3>
            <div class="chart-controls">
              <button type="button" class="sort-btn" (click)="toggleProjectedConsumptionBarChartSort()" [title]="projectedConsumptionBarChartSort === 'desc' ? 'Sort ascending' : 'Sort descending'">
                <mat-icon>{{ projectedConsumptionBarChartSort === 'desc' ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              </button>
              <button
                *ngIf="shouldShowForecastToggle()"
                type="button"
                class="show-all-btn"
                (click)="toggleShowAllForecastItems()"
                [title]="getForecastToggleTitle()">
                <mat-icon>{{ showAllForecastItems ? 'unfold_less' : 'unfold_more' }}</mat-icon>
              </button>
            </div>
          </div>
          <div class="chart-body chart-body-large">
            <div *ngIf="isLoadingForecastConsumption" class="loading-overlay">
              <div class="spinner"></div>
            </div>
            <div *ngIf="!isLoadingForecastConsumption && hasNoData(projectedConsumptionBarChartLabels, projectedConsumptionBarChartData)" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">insert_chart</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No forecast data found for the selected filters</p>
            </div>
            <div class="chart-wrapper" *ngIf="!isLoadingForecastConsumption && !hasNoData(projectedConsumptionBarChartLabels, projectedConsumptionBarChartData) && projectedConsumptionBarChartLabels.length > 0 && projectedConsumptionBarChartData.length > 0">
              <canvas baseChart
                #projectedConsumptionBarChart
                [labels]="projectedConsumptionBarChartLabels"
                [datasets]="projectedConsumptionBarChartData"
                [options]="getForecastBarChartOptions(filters.breakdownBy !== 'product')"
                [colors]="barChartColors"
                [chartType]="'bar'">
              </canvas>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 forecast-col">
        <div class="data-card forecast-table-tall">
          <h3>Projected Consumption by {{ filters.breakdownBy !== 'product' ? getBreakdownDisplayName(filters.breakdownBy) : 'Product' }} (lbs)</h3>
          <div class="table-container">
            <div *ngIf="isLoadingForecastConsumption" class="loading-overlay">
              <div class="spinner-dots">
                <div class="spinner-dot"></div>
                <div class="spinner-dot"></div>
                <div class="spinner-dot"></div>
              </div>
            </div>
            <div *ngIf="!isLoadingForecastConsumption && hasNoData(projectedConsumptionBarChartLabels, projectedConsumptionBarChartData)" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">table_chart</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No forecast data found for the selected filters</p>
            </div>
            <table class="data-table" *ngIf="!isLoadingForecastConsumption && !hasNoData(projectedConsumptionBarChartLabels, projectedConsumptionBarChartData) && projectedConsumptionBarChartLabels.length > 0 && projectedConsumptionBarChartData.length > 0">
              <thead>
                <tr>
                  <th>{{ filters.breakdownBy !== 'product' ? getBreakdownDisplayName(filters.breakdownBy) : 'Product' }}</th>
                  <!-- Simple format: single column -->
                  <th *ngIf="!isForecastStacked()" class="text-right">Projected (lbs)</th>
                  <!-- Stacked format: one column per product -->
                  <ng-container *ngIf="isForecastStacked()">
                    <th *ngFor="let dataset of projectedConsumptionBarChartData" class="text-right">{{ dataset.label }}</th>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let label of projectedConsumptionBarChartLabels; let i = index">
                  <td>
                    <span
                      *ngIf="shouldShowContextualTooltip() && getContextualTooltip(label)"
                      (mouseenter)="onTooltipMouseEnter($event, label)"
                      (mouseleave)="onTooltipMouseLeave()">
                      {{ label }}
                    </span>
                    <span *ngIf="!shouldShowContextualTooltip() || !getContextualTooltip(label)">
                      {{ label }}
                    </span>
                  </td>
                  <!-- Simple format: single value -->
                  <td *ngIf="!isForecastStacked()" class="text-right">{{ getForecastValue(i) | number:'1.2-2' }}</td>
                  <!-- Stacked format: one value per product -->
                  <ng-container *ngIf="isForecastStacked()">
                    <td *ngFor="let dataset of projectedConsumptionBarChartData; let j = index" class="text-right">
                      {{ getForecastValueForProduct(j, i) | number:'1.2-2' }}
                    </td>
                  </ng-container>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td class="font-semibold">Total</td>
                  <!-- Simple format: single total -->
                  <td *ngIf="!isForecastStacked()" class="text-right font-semibold">
                    {{ getForecastBarChartTotal() | number:'1.2-2' }}
                  </td>
                  <!-- Stacked format: one total per product -->
                  <ng-container *ngIf="isForecastStacked()">
                    <td *ngFor="let dataset of projectedConsumptionBarChartData; let j = index" class="text-right font-semibold">
                      {{ getForecastTotalForProduct(j) | number:'1.2-2' }}
                    </td>
                  </ng-container>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Row 2 -->
    <div class="row forecast-row kt-margin-b-25">
      <div class="col-md-8 forecast-col">
        <div class="chart-card">
          <h3>Inventory Projection (Next {{ forecastDays }} Days)</h3>
          <div class="chart-body chart-body-large">
            <div *ngIf="isLoadingInventoryProjection" class="loading-overlay">
              <div class="spinner"></div>
            </div>
            <div *ngIf="!isLoadingInventoryProjection && hasInsufficientTimeseriesData(inventoryProjectionLabels)" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">timeline</mat-icon>
              <h3 class="chart-empty-state__title">Insufficient time range selected</h3>
              <p class="chart-empty-state__subtitle">Please select a wider date range to view trends over time</p>
            </div>
            <div *ngIf="!isLoadingInventoryProjection && !hasInsufficientTimeseriesData(inventoryProjectionLabels) && hasNoData(inventoryProjectionLabels, inventoryProjectionData)" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">timeline</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No inventory projection data found for the selected filters</p>
            </div>
            <div class="chart-wrapper" *ngIf="!isLoadingInventoryProjection && !hasInsufficientTimeseriesData(inventoryProjectionLabels) && !hasNoData(inventoryProjectionLabels, inventoryProjectionData) && inventoryProjectionLabels.length > 0 && inventoryProjectionData.length > 0">
              <canvas baseChart
                #inventoryProjectionLineChart
                [labels]="inventoryProjectionLabels"
                [datasets]="inventoryProjectionData"
                [options]="lineChartOptions"
                [colors]="lineChartColors"
                [chartType]="'line'">
              </canvas>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 forecast-col">
        <div class="data-card forecast-table-tall">
          <h3>Inventory Projection Summary (lbs)</h3>
          <div class="table-container">
            <div *ngIf="isLoadingInventoryProjection" class="loading-overlay">
              <div class="spinner-dots">
                <div class="spinner-dot"></div>
                <div class="spinner-dot"></div>
                <div class="spinner-dot"></div>
              </div>
            </div>
            <div *ngIf="!isLoadingInventoryProjection && inventoryProjectionTable.length === 0" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">table_chart</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No inventory projection data found for the selected filters</p>
            </div>
            <table class="data-table" *ngIf="!isLoadingInventoryProjection && inventoryProjectionTable.length > 0">
              <thead>
                <tr>
                  <th>Product</th>
                  <th class="text-right">Current (lbs)</th>
                  <th class="text-right">Projected End (lbs)</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of inventoryProjectionTable">
                  <td>{{ row.product }}</td>
                  <td class="text-right">{{ row.current | number:'1.2-2' }}</td>
                  <td class="text-right">{{ row.projectedEnd | number:'1.2-2' }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td class="font-semibold">Total</td>
                  <td class="text-right font-semibold">
                    {{ getInventoryProjectionCurrentTotal() | number:'1.2-2' }}
                  </td>
                  <td class="text-right font-semibold">
                    {{ getInventoryProjectionEndTotal() | number:'1.2-2' }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Row 3 -->
    <div class="row forecast-row">
      <div class="col-md-8 forecast-col">
        <div class="chart-card forecast-chart-short">
          <h3>Projected Consumption Over Time</h3>
          <div class="chart-body chart-body-forecast-short">
            <div *ngIf="isLoadingForecastConsumptionOverTime" class="loading-overlay">
              <div class="spinner"></div>
            </div>
            <div *ngIf="!isLoadingForecastConsumptionOverTime && hasInsufficientTimeseriesData(forecastLineLabels)" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">timeline</mat-icon>
              <h3 class="chart-empty-state__title">Insufficient time range selected</h3>
              <p class="chart-empty-state__subtitle">Please select a wider date range to view trends over time</p>
            </div>
            <div *ngIf="!isLoadingForecastConsumptionOverTime && !hasInsufficientTimeseriesData(forecastLineLabels) && hasNoData(forecastLineLabels, forecastLineData)" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">timeline</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No forecast data found for the selected filters</p>
            </div>
            <div class="chart-wrapper" *ngIf="!isLoadingForecastConsumptionOverTime && !hasInsufficientTimeseriesData(forecastLineLabels) && !hasNoData(forecastLineLabels, forecastLineData) && forecastLineLabels.length > 0 && forecastLineData.length > 0">
              <canvas baseChart
                #forecastLineChart
                [labels]="forecastLineLabels"
                [datasets]="forecastLineData"
                [options]="lineChartOptions"
                [colors]="lineChartColors"
                [chartType]="'line'">
              </canvas>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 forecast-col">
        <div class="data-card forecast-table-short">
          <h3>Projected Consumption Data (lbs)</h3>
          <div class="table-container">
            <div *ngIf="isLoadingForecastConsumptionOverTime" class="loading-overlay">
              <div class="spinner-dots">
                <div class="spinner-dot"></div>
                <div class="spinner-dot"></div>
                <div class="spinner-dot"></div>
              </div>
            </div>
            <div *ngIf="!isLoadingForecastConsumptionOverTime && hasNoData(forecastLineLabels, forecastLineData)" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">table_chart</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No forecast data found for the selected filters</p>
            </div>
            <table class="data-table" *ngIf="!isLoadingForecastConsumptionOverTime && !hasNoData(forecastLineLabels, forecastLineData) && forecastLineLabels.length > 0 && forecastLineData.length > 0">
              <thead>
                <tr>
                  <th>Date</th>
                  <th *ngFor="let ds of forecastLineData" class="text-right">{{ ds.label }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let label of forecastLineLabels; let di = index">
                  <td>{{ label }}</td>
                  <td *ngFor="let ds of forecastLineData" class="text-right">
                    {{ (ds.data[di] || 0).toFixed(2) }}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td class="font-semibold">Total</td>
                  <td *ngFor="let ds of forecastLineData" class="text-right font-semibold">
                    {{ getForecastLineTotal(ds) | number:'1.2-2' }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

